module.exports = __webpack_public_path__ + "img/Axima_logo-2048x843.d10cf418.png";